<!--
  ~ Copyright (c) 2020. Sayari LLC
  -->

<!--The content below is only a placeholder and can be replaced.-->
<app-header></app-header>
<div class="container mt40">
    <section class="row" style="padding-top: 20px">
        <div *ngIf="specialsNotFound" class="col-sm-2 col-centered">
            No specials found
        </div>
        <div *ngFor="let special of specials">
            <article class="col-md-5 col-centered">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <img src="{{special.imageUrl}}"
                             alt="{{special.title}}" style="height: auto;">
                    </div>
                    <div>
                        <div class="panel-heading">
                            <h4 class="panel-title">

                                <a class="accordion-toggle collapsed" data-toggle="collapse" aria-expanded="false"
                                   href="#SPK{{special.imageFileName.substring(0, special.imageFileName.length - 4)}}">{{special.title}}</a>

                            </h4>
                        </div>
                        <div style="padding-right: 10px;padding-left: 10px">
                            <div class="panel-collapse collapse"
                                 id="SPK{{special.imageFileName.substring(0, special.imageFileName.length - 4)}}">
                                <div class="card card-body" style="border-top: 1px solid #efefef"
                                     *ngIf="special.description.length > 0">
                                    {{special.description}}
                                </div>
                                <div class="card card-body" style="border-top: 1px solid #efefef">
                                  <span class="glyphicon glyphicon-calendar venue-icon-color"
                                        style="padding-right: 10px; color:cornflowerblue"></span>
                                    <span>{{special.daysDisplay}}</span>
                                    <span class="span-right">{{special.startTime | date:'h:mma'}} - {{special.endTime | date:'h:mma'}}</span>

                                </div>
                                <div id="venue-title" class="card card-body" style="border-top: 1px solid #efefef">
                                    <a data-toggle="modal" data-target="#myModal" attr.data-lat={{special.venue.latitude}}
                                       attr.data-lng={{special.venue.longitude}}
                                       attr.data-venue-name={{special.venue.businessName}}
                                       attr.data-venue-street1={{special.venue.streetAddress1}}
                                       attr.data-venue-street2={{special.venue.streetAddress2}}
                                       attr.data-venue-city={{special.venue.city}} attr.data-venue-state={{special.venue.state}}
                                       attr.data-venue-zipcode={{special.venue.zipCode}}>
                                  <span class="glyphicon glyphicon-home venue-icon-color"
                                        style="padding-right: 10px"></span>{{special.venue.businessName}}<span
                                            class="span-right">{{special.distance}} mi</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>

        <div *ngIf="this.showLoadMoreButton">
            <article class="col-md-5 col-centered" >
                <a class="btn btn-block btn-primary col-centered" (click) = "loadMore()" >Load More...</a>
            </article>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="myModalLabel"></h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 modal_body_content">
                                <p id="address"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 modal_body_map">
                                <div class="location-map" id="location-map">
                                    <div style="width: 600px; height: 400px;" id="map_canvas"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>




